module.exports = __webpack_public_path__ + "media/images/recrutare/carousel/carousel_3-e295f4c628e2e396b2bc0d5c97f69e04.jpg";